import { ApolloProvider } from '@apollo/client';
import { useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import { createApolloClient } from './utils/apolloUtils';
import SessionExpiredDialog from './SessionExpiredDialog';
import EmailChallengedDialog from './EmailChallengedDialog';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const AuthApolloProvider = _ref => {
  let {
    children,
    brandCode
  } = _ref;
  const [user, setUser] = useState(null);
  const [isUnauthDialogOpen, setIsUnauthDialogOpen] = useState(false);
  const [emailChallengedInfo, setEmailChallengedInfo] = useState(null);
  const location = useLocation();
  const {
    routes
  } = window.spa_variables;
  const needsPostBookingAuthentication = [routes['rf.order.action'], routes['postbooking.products.action']].some(route => location.pathname.endsWith(route));
  const unauthorizedRedirectionUrl = needsPostBookingAuthentication ? routes['postbooking.authentication.action'] : routes['rf.order.authentication.action'];
  const handleCloseSessionExpiredDialog = () => {
    setIsUnauthDialogOpen(false);
  };
  const handleCloseEmailChallengedDialog = () => {
    setEmailChallengedInfo(null);
  };
  const apolloClient = useMemo(() => {
    return createApolloClient(setUser, setIsUnauthDialogOpen, setEmailChallengedInfo);
  }, [setIsUnauthDialogOpen]);
  return /*#__PURE__*/_jsx(ApolloProvider, {
    client: apolloClient,
    children: /*#__PURE__*/_jsxs(AuthProvider, {
      setIsUnauthDialogOpen: setIsUnauthDialogOpen,
      setUser: setUser,
      user: user,
      children: [children, /*#__PURE__*/_jsx(SessionExpiredDialog, {
        brandCode: brandCode,
        handleButtonClick: handleCloseSessionExpiredDialog,
        isOpen: isUnauthDialogOpen,
        unauthorizedRedirectionUrl: unauthorizedRedirectionUrl
      }), /*#__PURE__*/_jsx(EmailChallengedDialog, {
        brandCode: brandCode,
        emailChallengedInfo: emailChallengedInfo,
        handleCloseButtonClick: handleCloseEmailChallengedDialog,
        isOpen: emailChallengedInfo !== null,
        unauthorizedRedirectionUrl: unauthorizedRedirectionUrl
      })]
    })
  });
};
export { AuthApolloProvider };
//# sourceMappingURL=AuthApolloContext.js.map